import { memo } from "react";
import { PlanCardChrome } from "@sudowrite/shared-chat";
import type { PlanData, PlanStepData } from "src/stores/persistentChatStore";
import { sendAppEvent } from "src/Utils";
import { planCardWebIcons } from "../planCardWebIcons";

export type { PlanData, PlanStepData };

type Props = {
  plan: PlanData;
  mode: "floating" | "inline";
  maxStepsHeight?: string;
  onApprove?: (removedStepIds: string[]) => void;
  onCancel?: () => Promise<void> | void;
  onPause?: () => Promise<void> | void;
  onResume?: () => void;
  resumeInFlight?: boolean;
  pauseInFlight?: boolean;
  onDuplicatePlan?: () => void;
  onEditModeChange?: (isEditing: boolean) => void;
  onSaveEdits?: (steps: PlanStepData[], planEdits?: { description: string; specialConsiderations?: string }) => void;
};

export const PlanCard = memo((props: Props) => (
  <PlanCardChrome
    {...props}
    icons={planCardWebIcons}
    onAnalyticsEvent={(event, payload) => {
      void sendAppEvent(event, payload);
    }}
  />
));
